import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'

// 中国国内物流状態
export const getLogisticsList = data => Vue.prototype.getAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=getLogisticsList", data)

// 中国国内物流详情
export const deliveryStatus = data => Vue.prototype.getAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=deliveryStatus", data)